<template>
  <div class="text--primary">
    <v-row>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Site</span>
        <div>
          {{ fornecedor.fornecedor.site | naoInformado }}
          <v-btn icon :href="site" target="_blank" v-if="site">
            <v-icon small>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="fornecedor.observacoesInternas"/>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Código interno</span>
        <div>
          {{ fornecedor.codigoInterno | naoInformado }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    fornecedor: Object,
  },
  computed: {
    site() {
      if (!this.fornecedor.fornecedor.site) {
        return null;
      }
      if (this.fornecedor.fornecedor.site.includes('http://')
        || this.fornecedor.fornecedor.site.includes('https://')) {
        return this.fornecedor.fornecedor.site;
      }
      return `https://${this.fornecedor.fornecedor.site}`;
    },
  },
};
</script>
